import React, { useState } from 'react';
import { SCREEN_MAX_WIDTH, useGlobalState } from './stateProvider/StateProvider';
import styled from 'styled-components';
import Card from './forms/Card';
import { addSpacesToPascalCase, generateId } from './utility/functions';
import { QuestRoute } from './api/QuestRoutes';
import HamQuest from './api/HamQuestGiver';
import Form from './forms/Form';
import Col from './layout/Col';
import Preput from './forms/Preput';
import ModalFactory from './Modal';

const ToolTip = styled(Card)`
    position: absolute;
    margin: 0.5em;
    padding: 0.5em;
    z-index: 10000;
    background: ${({ theme }) => theme.background};
    pointer-events: none;
    transition: opacity 0.2s;
    border-radius: 0.2em;
    border: 1px solid ${({ theme }) => theme.gray};
    font-size: 0.7em;
    max-width: 30svw;
    @media (max-width: ${SCREEN_MAX_WIDTH}) {
        display: none;
    }
`

const Backdrop = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    background: ${({ theme }) => theme.gray}50;
    width: 100svw;
    height: 100svh;
    z-index: 9999;
    transition: opacity 0.2s;
    pointer-events: none;
`

const Pre = styled.pre`
    font-family: inherit;
    margin: 0;
    // font-weight: bold;
    white-space: pre-wrap;
`

export const HelpToolContext = React.createContext();

const HelpToolTip = ({ children, ...props }) => {
    const {
        state: { help },
        getTooltips
    } = useGlobalState();

    const [hoverTip, setTooltip] = useState({ content: '', pos: [0, 0], opacity: 0 });

    const setHoverTip = (event, content, opacity) => setTooltip({ pos: [event.clientX, event.clientY], content, opacity })

    const updateHelp = (formName, inputName) => {
        const id = generateId();
        // console.log(formName, inputName)
        const message = help[formName] ?? {};
        ModalFactory.show({
            id,
            title: (message[inputName] ? 'Edit' : 'Add') + ' Tooltip',
            body: (
                <Col>
                    <span>Add a help message to: <b>{addSpacesToPascalCase(formName)} - {addSpacesToPascalCase(inputName)}</b></span>
                    <Form
                        inputs={{ message: message[inputName] ?? '' }}
                        onSubmit={e => (
                            HamQuest.post(QuestRoute.tooltips, {
                                ...e, inputName, formName
                            })
                                .then(() => {
                                    getTooltips()
                                    ModalFactory.close(id)
                                })
                        )}
                    >
                        <Preput
                            label='Tooltip Message'
                            name='message'
                            required
                        />
                    </Form>
                </Col>
            )
        })
    }

    const removeHelp = (formName, name) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: 'Remove Tooltip',
                body: <span>Are you sure you want to remove: <b>{addSpacesToPascalCase(formName)} - {addSpacesToPascalCase(name)}</b></span>,
                closeAfter: true
            },
            promise: {
                title: 'Removing Tooltip',
                callback: () => HamQuest.delete(`${QuestRoute.tooltips}/${formName}/${name}`),
            },
            finally: () => getTooltips()
        })
    }

    const contextValues = {
        setHoverTip,
        updateHelp,
        removeHelp
    }

    return (
        <HelpToolContext.Provider value={contextValues}>
            <Backdrop style={{ opacity: hoverTip.opacity }} />
            <ToolTip
                style={{
                    left: `${hoverTip.pos[0] + 20}px`,
                    top: `${hoverTip.pos[1]}px`,
                    opacity: hoverTip.opacity,
                }}
            >
                <Pre>{hoverTip.content}</Pre>
            </ToolTip>
            {children}
        </HelpToolContext.Provider >
    );
}

export default HelpToolTip;